import React from 'react'
import PropTypes from 'prop-types'
import { useParams } from 'react-router-dom'

import { DiscardButton, SaveButton } from '~/components/Buttons'
import PageTitle from '~/components/PageTitle'
import Container, { Content, Header } from '~/components/Container'
import { withForm } from '~/components/Form'
import * as NAV from '~/constants/nav-titles'
import Divider from '~/components/Divider'
import { INTEGRATION_TABS } from '~/constants/tabs'
import IntegrationHistory from '~/components/IntegrationHistory/IntegrationHistory'
import { WOO_COMMERCE } from '~/constants/integrationTypes'
import * as ROUTES from '~/constants/routes'

import WooCommerceIntegrationUpdateTabs from './WooCommerceIntegrationUpdateTabs'

import More from '../IntegrationDelete/More'
import WooCommerceUpdate from '../WooCommerce/WooCommerceUpdate'

function WooCommerceIntegrationUpdateForm (props) {
  const { pageTitle, pageTitleLoading, isLoading, form, onRemove, history, onRetry, retryLoading } = props
  const { tab } = useParams()

  const { handleSubmit } = form

  return (
    <form onSubmit={handleSubmit}>
      <Container>
        <Header>
          <PageTitle
            parentTitle={NAV.INTEGRATION}
            pageTitle={pageTitle}
            pageTitleLoading={pageTitleLoading}
            rightButton={
              <>
                <DiscardButton to={ROUTES.INTEGRATION_LIST_PATH} disabled={isLoading} />
                <SaveButton disabled={isLoading} />
                <More onRemove={onRemove} />
              </>
            }
          />
        </Header>
        <Content>
          <WooCommerceIntegrationUpdateTabs />
          <Divider />
          {tab === INTEGRATION_TABS.GENERAL && <WooCommerceUpdate />}
          {tab === INTEGRATION_TABS.LOGS && (
            <IntegrationHistory
              history={history}
              integrationType={WOO_COMMERCE}
              onRetry={onRetry}
              retryLoading={retryLoading}
              onRefetch={history.getListByParams}
            />
          )}
        </Content>
      </Container>
    </form>
  )
}

WooCommerceIntegrationUpdateForm.propTypes = {
  pageTitle: PropTypes.string,
  pageTitleLoading: PropTypes.bool.isRequired,
  isLoading: PropTypes.bool,
  form: PropTypes.object.isRequired,
  onRemove: PropTypes.func.isRequired,
  history: PropTypes.object.isRequired,
  onRetry: PropTypes.func,
  retryLoading: PropTypes.bool
}

export default withForm(WooCommerceIntegrationUpdateForm)
